import a from "./td-longtail-vue-components149.js";
/* empty css                              */
import o from "./td-longtail-vue-components98.js";
var n = function() {
  var t = this, e = t._self._c, s = t._self._setupProxy;
  return t.text ? e("span", { staticClass: "square-badge", class: s.className, attrs: { tabindex: t.footnoteText || !!t.clickBadge !== void 0 ? 0 : void 0 }, on: { click: s.handleClick } }, [e("span", { staticClass: "square-badge__content", domProps: { innerHTML: t._s(t.text) } }), t.footnoteText || t.clickBadge !== void 0 ? e("span", { staticClass: "square-badge__footnote-btn btn btn--footnote" }, [t._v(" * ")]) : t._e()]) : t._e();
}, r = [], _ = /* @__PURE__ */ o(
  a,
  n,
  r,
  !1,
  null,
  "6d1c53df"
);
const f = _.exports;
export {
  f as default
};
